import { differenceInCalendarDays, parseISO } from 'date-fns';

import { ProductState } from '../../checkout/resourceSelection/redux/types';
import { type TermedLevel, TermedLevelState } from '../../common/termedLevel/types';

export type BookingOverviewStatus = 'ACTIVE' | 'PENDING' | 'EXPIRING' | 'UNASSIGNED';

export function getBookingOverviewStatus(
    contract: Pick<TermedLevel, 'state' | 'activationState' | 'endsAt' | 'renewsToLevel'>,
    today = new Date()
): BookingOverviewStatus {
    const { state, activationState, endsAt, renewsToLevel } = contract;

    if (
        (state === TermedLevelState.ACTIVE &&
            (activationState === ProductState.PENDING_CANCELLATION || activationState === ProductState.INACTIVE)) ||
        (state === TermedLevelState.PENDING && activationState === ProductState.INACTIVE)
    ) {
        return 'UNASSIGNED';
    }

    if (
        (state === TermedLevelState.PENDING && activationState !== ProductState.INACTIVE) ||
        (state === TermedLevelState.ACTIVE && activationState === ProductState.PENDING_ACTIVATION)
    ) {
        return 'PENDING';
    }

    if (
        state === TermedLevelState.ACTIVE &&
        activationState === ProductState.ACTIVE &&
        endsAt &&
        renewsToLevel === undefined
    ) {
        const remainingDays = differenceInCalendarDays(parseISO(endsAt), today);
        if (remainingDays >= 0 && remainingDays <= 31) {
            return 'EXPIRING';
        }
    }
    return 'ACTIVE';
}
